<script lang="ts" setup>
import type { LordIcon } from '~/types/assets'
import { LordIconSource, LordIconTrigger, Iconify } from '~/types/assets'

const iconMail: LordIcon = {
  src: LordIconSource.mail,
  trigger: LordIconTrigger.loop,
  revert: true,
  delay: 500,
  loading: 'lazy',
  size: 'w-12 h-12 lg:w-16 lg:h-16'
}
</script>

<template lang="pug">
KinesisContainer.contacts__beta(
  tag="section"
)
  KinesisElement(
    tag="h2"
    :strength="20"
  ) {{ $t('contacts.beta.title') }}
  KinesisElement(
    tag="p"
    :strength="20"
  ) {{ $t('contacts.beta.socials-intro') }}
  KinesisElement(
    tag="ul"
    type="depth"
    :strength="30"
  )
    li
      a(href="https://www.instagram.com/lorenzorottigni/", rel="nofollow")
        Icon(:name="Iconify?.instagram")
    li
      a(href="https://www.discord.com/", rel="nofollow")
        Icon(:name="Iconify?.discord")
    li
      a(href="https://www.slack.com/", rel="nofollow")
        Icon(:name="Iconify?.slack")
    li
      a(href="https://www.linkedin.com/in/lorenzo-rottigni-ba402b222/", rel="nofollow")
        Icon(:name="Iconify?.linkedin")
  KinesisElement(tag="p" :strength="20") {{ $t('contacts.beta.emails-intro') }}
  KinesisElement(tag="ol" :strength="20")
    li
      a(href="mailto:lorenzo@rottigni.net")
        IconLord(v-bind="iconMail")
        span lorenzo@rottigni.net
    li
      a(href="mailto:lorenzo@rottigni.tech")
        IconLord(v-bind="iconMail")
        span lorenzo@rottigni.tech
</template>

<style lang="sass" scoped>
section.contacts__beta
  @apply w-full h-full flex-center flex-col gap-4 lg:gap-6 lg:px-12
  h2
    @apply text-3xl lg:text-4xl text-primary font-bold text-animated
  p
    @apply text-xs lg:text-lg text-white text-center
  ul
    @apply lg:p-2 lg:rounded-[50%] flex-center flex-wrap overflow-hidden
    li
      @apply w-[65px] lg:w-[15vh] h-[10vh] lg:h-[15vh] p-1 lg:p-2
      a
        @apply bg-primary hover:bg-dark-800 h-full w-full flex-center rounded-xl text-dark-900 transition-all shadow-xl
        &:hover > *
          @apply text-secondary
        & > *
          @apply text-2xl lg:text-4xl
  ol
    @apply flex-col
    li
      @apply w-full
      a
        @apply text-primary flex-center text-xl lg:text-2xl gap-4
</style>
